<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit">
        <template #급여>
            <v-row class="row--small">
                <v-col cols="12" lg="5">
                    <v-select v-model="form.employment.wage.type" :items="wageTypes" :menuProps="{ attach: '.form-employment-wage-type' }" class="form-employment-wage-type" attach outlined @change="onChangeWageType" />
                </v-col>
                <v-col cols="12" lg="7">
                    <v-row align="center" class="row--small">
                        <v-col cols="12" md=""> <v-currency-field v-model="form.employment.wage.value__min" :label="`최소금액`" outlined suffix="원" class="text-right" @input="emit" /> </v-col>
                        <v-col cols="auto"> ~ </v-col>
                        <v-col> <v-currency-field v-model="form.employment.wage.value__max" :label="`최대금액`" outlined suffix="원" class="text-right" @input="emit" /> </v-col>
                    </v-row>
                </v-col>
                <v-expand-transition>
                    <v-col cols="12" v-show="!isWageDisabled">
                        <v-btn small text color="primary" href="http://www.minimumwage.go.kr/index.jsp" target="_blank" class="mx-n12">
                            <v-layout justify-start align-center>
                                <span> 최저임금제도 바로가기 </span>
                                <i class="icon icon-right-arrow-sm ml-4 ml-lg-8"></i>
                                <v-chip-group class="ml-10">
                                    <v-chip color="grey-f8" class="grey--text"> 시급 9,629원 </v-chip>
                                    <v-chip color="grey-f8" class="grey--text"> 일급 76.960원 </v-chip>
                                    <v-chip color="grey-f8" class="grey--text"> 월급 2,010,580원 </v-chip>
                                </v-chip-group>
                            </v-layout>
                        </v-btn>
                    </v-col>
                </v-expand-transition>
            </v-row>
        </template>
    </vertical-form-table>
</template>

<script>
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import { EMPLOYMENT_TYPES, initRecruitment, WAGE_TYPES } from "@/assets/variables";

const wageTypes = Object.values(WAGE_TYPES);
const wageTypes__disabled = [WAGE_TYPES.REFERENCE_TO_INTERVIEW.value, WAGE_TYPES.REFERENCE_TO_RULE_BOOK.value, WAGE_TYPES.REFERENCE_TO_VIEW_PAGE.value];

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initRecruitment },
    },
    data: () => ({
        form: initRecruitment(),
        wageTypes,
    }),
    computed: {
        items() {
            return [
                {
                    key: "employment.types",
                    term: "근무유형",
                    type: "select",
                    items: Object.values(EMPLOYMENT_TYPES),
                    class: "form-employment-type",
                    menuProps: { attach: ".form-employment-type" },
                    multiple: true,
                    required: true,
                },
                {
                    key: "employment.place",
                    term: "근무지",
                    type: "address",
                    hasAbroadOption: true,
                    btnAttrs: { color: "#666666", className: "mt-n8 w-100px white--text" },
                    required: true,
                },
                {
                    term: "급여",
                    required: true,
                },
                // {
                //     key: "employment",
                //     term: "근무기간",
                //     type: "dates",
                // },
            ].map((item) => ({ ...item, outlined: true, attach: true }));
        },
        isWageDisabled() {
            return wageTypes__disabled.includes(this.form?.employment?.wage?.type);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitment(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        onChangeWageType(value) {
            if (wageTypes__disabled.includes(value)) {
                this.form.employment.wage.value__min = 0;
                this.form.employment.wage.value__max = 0;
            }
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
.row--small {
    margin: -5px -2px;
    > [class*="col"] {
        padding: 5px 2px;
    }
}
::v-deep {
    .v-chip.v-size--default {
        font-size: 1.4rem;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .row--small {
        margin: -5px;
        > [class*="col"] {
            padding: 5px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>